import { Controller } from "@hotwired/stimulus"

// FD-913: filter a list that is rendered whole, client-side. Typing hides every row whose
// name doesn't contain the query (case-insensitive); the empty row shows when nothing is
// left; Escape clears the box. A row's name comes from its data-list-filter-name, not its
// text, so a row whose name lives in an <input> (the settings label rows) still matches.
export default class extends Controller {
  static targets = ["input", "row", "empty"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let visible = 0
    this.rowTargets.forEach((row) => {
      const name = (row.dataset.listFilterName || "").toLowerCase()
      row.hidden = query !== "" && !name.includes(query)
      if (!row.hidden) visible++
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = query === "" || visible > 0
  }

  clear(event) {
    if (event.key !== "Escape" || this.inputTarget.value === "") return
    event.preventDefault()
    this.inputTarget.value = ""
    this.filter()
  }
}
